
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"50","height":"50","rx":"25","fill":"#00A351"}}),_c('path',{attrs:{"d":"M17.46 21.209h-2.583c-.714 0-1.292.578-1.292 1.292v10.333c0 .713.578 1.292 1.292 1.292h2.583c.713 0 1.292-.579 1.292-1.292V22.501c0-.714-.579-1.292-1.292-1.292zM20.042 23.056c0-.361.077-.723.232-1.059l4.353-9.662a2.302 2.302 0 012.145-1.446 2.31 2.31 0 012.312 2.312v5.438h6.458c1.42 0 2.583 1.15 2.583 2.583l-2.17 10.85a2.597 2.597 0 01-2.531 2.08H23.232c-.4 0-.8-.09-1.15-.272l-.606-.31a2.583 2.583 0 01-1.434-2.312v-8.202z","fill":"#fff"}})])
          )
        }
      }
    